import React from 'react';
import i18n from 'i18next';
import { Trans } from 'react-i18next';

type OutdatedBrowsersTipsProps = {
    onDownloadApplication?: () => void;
};

export const OutdatedBrowsersTips = ({ onDownloadApplication }: OutdatedBrowsersTipsProps) => (
    <div className='join-steps-wrapper'>
        <h3 className='welcome-text'>
            {i18n.t('DOWNLOAD.web_join_steps.browser_unsupported_reason')}
        </h3>
        {onDownloadApplication && (
            <p className='outdated-tips'>
                <Trans
                    i18nKey='DOWNLOAD.DOWNLOAD_TIP.OUTDATED'
                    components={{
                        download: (
                            /* eslint-disable jsx-a11y/anchor-is-valid */
                            <a
                                onClick={() => onDownloadApplication()}
                                data-at='DownloadPage::Link::DownloadTip'
                            />
                        ),
                    }}
                    values={{ applicationName: `${i18n.t('DOWNLOAD.APPLICATION')} app` }}
                />
            </p>
        )}
    </div>
);
